"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var LiveScheduledIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 12 12", fill: "currentColor", width: size || '12', height: size || '12' }, props),
        React.createElement("path", { fill: "currentColor", d: "M1 2h10a1 1 0 0 1 1 1v1H0V3a1 1 0 0 1 1-1zm10 10H1a1 1 0 0 1-1-1V5h12v6a1 1 0 0 1-1 1zM2 7v2h2V7H2zm0-7h1v2H2V0zm7 0h1v2H9V0z", fillRule: "evenodd" })));
};
LiveScheduledIcon.displayName = 'LiveScheduledIcon';
exports.default = LiveScheduledIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=LiveScheduledIcon.js.map